import { apiClient } from '@/hooks/useAxios';
import { CommonRes, TokenResponse } from '@/types';

const ApiPath = '/auth';

export const login = async (
  email: string,
  password: string,
): Promise<CommonRes<TokenResponse>> => {
  const res = await apiClient.post<CommonRes<TokenResponse>>(
    `${ApiPath}/login`,
    {
      email,
      password,
    },
  );
  return res.data;
};

export const register = async (
  name: string,
  email: string,
  password: string,
): Promise<CommonRes<{ id: string }>> => {
  const res = await apiClient.post<CommonRes<{ id: string }>>(
    `${ApiPath}/register`,
    {
      name,
      email,
      password,
    },
  );
  return res.data;
};

export const logout = async (): Promise<CommonRes<void>> => {
  const res = await apiClient.post(`${ApiPath}/logout`);
  return res.data;
};

export const refresh = async (): Promise<CommonRes<TokenResponse>> => {
  const res = await apiClient.post<CommonRes<TokenResponse>>(
    `${ApiPath}/refresh`,
  );
  return res.data;
};

export const forgotPassword = async (
  email: string,
): Promise<CommonRes<{ message: string }>> => {
  const res = await apiClient.post<CommonRes<{ message: string }>>(
    `${ApiPath}/forgot-password`,
    {
      email,
    },
  );
  return res.data;
};

export const verifyResetToken = async (
  token: string,
): Promise<CommonRes<{ valid: boolean; message?: string }>> => {
  const res = await apiClient.get<
    CommonRes<{ valid: boolean; message?: string }>
  >(`${ApiPath}/verify-reset-token`, {
    params: { token },
  });
  return res.data;
};

export const resetPassword = async (
  token: string,
  password: string,
): Promise<CommonRes<{ message: string }>> => {
  const res = await apiClient.post<CommonRes<{ message: string }>>(
    `${ApiPath}/reset-password`,
    {
      token,
      password,
    },
  );
  return res.data;
};

export const verifyEmail = async (
  token: string,
): Promise<CommonRes<{ message: string }>> => {
  const res = await apiClient.get<CommonRes<{ message: string }>>(
    `${ApiPath}/verify-email`,
    {
      params: { token },
    },
  );
  return res.data;
};
